export class GWFlight {
    public id: number;
    public eventId: number;
    public airlineIataCode: string;
    public airlineName: string;
    public flightNumber: string;
    public departureDate: string;
    public arrivalDate: string;
    public departureAirportIataCode: string;
    public arrivalAirportIataCode: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-flight.model.ts